import { render, staticRenderFns } from "./BillingData.vue?vue&type=template&id=928ead34"
import script from "./BillingData.vue?vue&type=script&lang=js"
export * from "./BillingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports